import * as React from 'react';
import Dialog, { DialogContent } from '@material/react-dialog';
import SearchInput from 'PyzShopUi/scripts/react/common/components/form/SearchInput';
import { searchValueObserver } from 'PyzShopUi/scripts/search-suggestion/includes/searchSuggestionHelper';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import { ReactFoundationEvent } from 'PyzShopUi/scripts/react/common/events/foundationEvent';

interface ISmallScreenLayoutProps {
    searchValue: string;
    isVisible: boolean;
    searchUrl: string;
    children?: React.ReactNode;

    onClose(): void;
}

export const SmallScreenLayout: React.FunctionComponent<ISmallScreenLayoutProps> = props => {
    const { searchValue, isVisible, children, searchUrl, onClose } = props;

    const [searchInputValue, setSearchInputValue] = React.useState<string>('');
    const middlewareEventBus = React.useRef<MiddlewareEventBus>(MiddlewareEventBus.getInstance());

    React.useEffect(() => {
        setSearchInputValue(searchValue);
    }, [searchValue]);

    const onSearchChange = (_: string, value: string) => {
        setSearchInputValue(value);
        searchValueObserver.next(value);
    };

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const newSearchUrl = new URL(searchUrl);
        newSearchUrl.searchParams.append('q', searchValue);
        window.location.href = newSearchUrl.toString();
    };

    const onTouchMove = () => {
        //Workaround for IOS Safari keyboard scroll behavior
        middlewareEventBus
            .current
            .publish({ type: ReactFoundationEvent.SMALL_SREEN_SUGGESSTION_ON_TOUCH_MOVE, payload: {} });
    };

    return (
        <div className="small-screen-suggest-result">
            <Dialog
                open={isVisible}
                onClose={() => onClose()}
                onTouchMove={() => onTouchMove()}>
                <DialogContent>
                    <div className="small-screen-suggest-result__header thin-line">
                        <i data-mdc-dialog-action={`close`} className="icon icon-size-standard icon-chevron-thin-left"/>
                        <SearchInput
                            value={searchInputValue}
                            isFullWidth={true}
                            onSearchChange={onSearchChange}
                            onSubmit={onSubmit}
                        />
                    </div>
                    <div className="small-screen-suggest-result__result-board">
                        {children}
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
};
